import BoiRetrieveCard from './BoiRetrieveCard';

export default BoiRetrieveCard;
